import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import { useUserAccess } from '../../context/UserAccessContext';
import { JUST_ONE_PAGE_NAME } from './justOnePageBrand';

const DEFAULT_DOCUMENT_TITLE = 'CRM Booster';

export default function WebCreatorLayout({ children }) {
  const location = useLocation();
  const { chooseAppMode, chooserOpen } = useUserAccess();
  const inEditor = location.pathname.includes('/web-creator/edit/');

  useEffect(() => {
    if (chooserOpen) return;
    chooseAppMode('web-creator');
  }, [chooseAppMode, chooserOpen]);

  useEffect(() => {
    document.title = JUST_ONE_PAGE_NAME;
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE;
    };
  }, []);

  return (
    <div className={`min-h-screen bg-background flex flex-col ${inEditor ? 'h-screen overflow-hidden' : ''}`}>
      <Header />
      <div className={`pt-16 flex flex-col ${inEditor ? 'flex-1 min-h-0' : ''}`}>{children}</div>
    </div>
  );
}
